import styled from "styled-components"

import {TransitionFeed} from "../../Feed"

const Feed = styled(TransitionFeed)`
  margin-bottom: ${({theme}) => theme.spacing.four};
`

export default Feed
